
// * ============================================================
// * ELEGIBILIDAD DE VARIABLES CLÍNICAS – SALVIR
// * ============================================================
// *
// * Este módulo determina si una variable clínica debe
// * mostrarse o no en el formulario según ciertas
// * condiciones clínicas o demográficas.
// *
// * El objetivo es controlar VISIBILIDAD en frontend.
// *
// * REGLA IMPORTANTE
// * ------------------------------------------------------------
// * Este módulo SOLO controla UI.
// * El backend sigue validando y normalizando valores
// * para exportación NOM.
// *
// * EJEMPLOS DE USO
// * ------------------------------------------------------------
// *
// * pediatría:
// *   edad < 18
// *
// * gerontología:
// *   edad >= 60
// *
// * embarazo:
// *   sexo = femenino
// *
// * Este archivo NO conoce React ni componentes.
// * Solo expone funciones puras.
// *



// ============================================================
// VARIABLES ESPECÍFICAS NOM
// ============================================================

// todas solo dependen de edad, las metemos en 1 canasta
export const variablesGerontologia = [

  "sintomaDepresiva",
  "alteracionMemoria",
  "aivdABVD",
  "sindromeCaidas",
  "incontinenciaUrinaria",
  "motricidad",
  "asesoriaNutricional"

];

//todas dependen de mujer y misma edad y de 3 variables madres, estas son las madres

export const variablesGinecologicas = [
  "atencionPregestacionalRT",
  "relacionTemporalEmbarazo",
  "puerpera"
];

// cada una de las hijas de las 3 madres
export const variablesPregestacion = [
    "riesgo"
];

export const variablesEmbarazo = [
 
  "trimestreGestacional",
  "primeraVezAltoRiesgo",
  "complicacionPorDiabetes",
  "complicacionPorInfeccionUrinaria",
  "complicacionPorPreeclampsiaEclampsia",
  "complicacionPorHemorragia",
  "hipertensionarterialprexistente",
  "otrasAccPrescAcidoFolico",
  "otrasACCApoyoTransladoAME"
];

export const variablesPuerperio = [
  "infeccionPuerperal"
];

// pediatria es mas compleja porque hay rangos diferentes de edad para todo, 
// por lo que hay mas variables aparte. muchas dependen de niño sano o de la anterior

export const variablesPediatria = [
  "ninoSanoRT",
  "resultadoBattelle",
];

export const variablesPruebaEDI = [
  "pruebaEDI"
];

export const variablesResultadoEDI = [
  "resultadoEDI"
];

export const variablesEDAS = [
  "edasRT"
];

export const variablesEDASPlan = [
  "edasPlanTratamiento"
];

export const variablesEDASRecuperacion = [
  "recuperadoDeshidratacion"
];

export const variablesIRAS = [
  "irasRT"
];

export const variablesIRASPlan = [
  "irasPlanTratamiento"
];

export const variablesNeumonia = [
  "neumoniaRT"
];
// ============================================================
// FUNCIÓN PRINCIPAL
// ============================================================

export const variableAplica = (nombreVariable, contexto = {}) => {

  const edad = contexto?.edad;
  const edadMeses = contexto?.edadMeses ?? null;
  const sexo = contexto?.sexo;
  const atencionPregestacionalRT = contexto?.atencionPregestacionalRT;
  const relacionTemporalEmbarazo = contexto?.relacionTemporalEmbarazo;
  const puerpera = contexto?.puerpera;
  const ninoSanoRT = contexto?.ninoSanoRT;
  const pruebaEDI = contexto?.pruebaEDI;
  const edasRT = contexto?.edasRT;
  const edasPlanTratamiento = contexto?.edasPlanTratamiento;
  const irasRT = contexto?.irasRT;
  
  // ------------------------------------------------------------
  // GERONTOLOGÍA
  // ------------------------------------------------------------

  if (variablesGerontologia.includes(nombreVariable)) {

    if (edad === undefined || edad === null) {
      return false;
    }

    return edad >= 60;
  }

  // ------------------------------------------------------------
  // FILTRO GINECOLÓGICO GENERAL
  // ------------------------------------------------------------

  const esGinecologico =
     variablesGinecologicas.includes(nombreVariable) ||
    variablesPregestacion.includes(nombreVariable) ||
    variablesEmbarazo.includes(nombreVariable) ||
    variablesPuerperio.includes(nombreVariable);

  if (esGinecologico) {

    if (sexo !== "F") return false;

    if (edad === undefined || edad === null) return false;

    if (edad < 9 || edad > 59) return false;
  }

  // ------------------------------------------------------------
  // VARIABLES GINECOLÓGICAS PRINCIPALES
  // ------------------------------------------------------------
  if (variablesGinecologicas.includes(nombreVariable)) {

    if (nombreVariable === "atencionPregestacionalRT") {

       if (relacionTemporalEmbarazo === 0 || relacionTemporalEmbarazo === 1) return false;
      if (puerpera === 0 || puerpera === 1) return false;
      return true;
    }

    if (nombreVariable === "relacionTemporalEmbarazo") {

      if (atencionPregestacionalRT === 0 || atencionPregestacionalRT === 1) return false;
      if (puerpera === 0 || puerpera === 1) return false;

      return true;
    }

    if (nombreVariable === "puerpera") {

      if (atencionPregestacionalRT === 0 || atencionPregestacionalRT === 1) return false;
      if (relacionTemporalEmbarazo === 0 || relacionTemporalEmbarazo === 1) return false;

      return true;
    }
  }
  // ------------------------------------------------------------
  // VARIABLES GINECOLOGICAS DEPENDIENTES DE PRINCIPALES
  // ------------------------------------------------------------

  if (variablesPregestacion.includes(nombreVariable)) {
     return atencionPregestacionalRT === "0" || atencionPregestacionalRT === "1";
  }

  if (variablesEmbarazo.includes(nombreVariable)) {
    return relacionTemporalEmbarazo === "0" || relacionTemporalEmbarazo === "1";
  }

  if (variablesPuerperio.includes(nombreVariable)) {
     
   return puerpera === "0" || puerpera === "1";
  }

  // ------------------------------------------------------------
  // PEDIATRÍA
  // ------------------------------------------------------------

  if (variablesPediatria.includes(nombreVariable)) {

      if (edad === undefined || edad === null) {
        return false;
      }

      // Niño sano
      if (nombreVariable === "ninoSanoRT") {
        return edad < 10;
      }

      // Battelle
      if (nombreVariable === "resultadoBattelle") {
        if (edadMeses === null) return false;
        return edadMeses >= 16 && edadMeses < 60;
      }

    }
       // PRUEBA EDI
   
          if (variablesPruebaEDI.includes(nombreVariable)) {

          if (edad === undefined || edad === null) return false;

          if (edad >= 6) return false;

          return ninoSanoRT === "0" || ninoSanoRT === "1";
          }

        // RESULTADO EDI
    

            if (variablesResultadoEDI.includes(nombreVariable)) {
            return pruebaEDI === "1" || pruebaEDI === "2";
          }

        // ------------------------------------------------------------
        // ENFERMEDAD DIARREICA AGUDA (EDA)
        // ------------------------------------------------------------

        if (variablesEDAS.includes(nombreVariable)) {
          if (edad === undefined || edad === null) return false;
          if (edad >= 5) return false;
          return ninoSanoRT !== "0" && ninoSanoRT !== "1";
        }

        // ------------------------------------------------------------
        // PLAN DE TRATAMIENTO EDA
        // ------------------------------------------------------------

        if (variablesEDASPlan.includes(nombreVariable)) {

          return edasRT === "0" || edasRT === "1";

        }
        // ------------------------------------------------------------
        // RECUPERACIÓN DESHIDRATACIÓN
        // ------------------------------------------------------------

        if (variablesEDASRecuperacion.includes(nombreVariable)) {

          if (!(edasRT === "0" || edasRT === "1")) return false;

          return edasPlanTratamiento === "2" || edasPlanTratamiento === "3";

        }

        // ------------------------------------------------------------
        // INFECCIÓN RESPIRATORIA AGUDA (IRA)
        // ------------------------------------------------------------

        if (variablesIRAS.includes(nombreVariable)) {

          if (edad === undefined || edad === null) return false;

          if (edad >= 5) return false;

          return ninoSanoRT !== "0" && ninoSanoRT !== "1";

        }
        // ------------------------------------------------------------
        // PLAN TRATAMIENTO IRA
        // ------------------------------------------------------------

        if (variablesIRASPlan.includes(nombreVariable)) {

          return irasRT === "0" || irasRT === "1";

        }
        
          // NEUMONÍA
          // ------------------------------------------------------------

          if (variablesNeumonia.includes(nombreVariable)) {

            return irasRT === "0" || irasRT === "1";

          }

  // ------------------------------------------------------------
  // VARIABLES SIN REGLAS
  // ------------------------------------------------------------

  return true;

};

export const aplicaConfirmacionDiagnostica = (dx, edad, esPrimeraVez) => {
  if (!dx) return false;

  const edadNum = parseFloat(edad);

  if (edadNum < 18 && String(dx.DIA_CAINFANTIL).trim().toUpperCase() === "SI") return true;

  if (esPrimeraVez && edadNum >= 20 && String(dx.DIA_CRONICOS).trim().toUpperCase() === "SI") return true;

  return false;
};